import * as update from "immutability-helper";
import * as DTOS from "../FeralScan.dtos";
import {
    GET_USER_GROUP_REQUEST,
    GET_USER_GROUP_SUCCESS,
    IGetUserGroupSuccessAction,
} from "../actions/usergroup.actions";

export type UserGroupState = {
    loading: boolean;
    metaData: DTOS.UserGroup;
};

const initialState: UserGroupState = {
    metaData: undefined,
    loading: false
};

export default function usergroup(state: UserGroupState = initialState, action) {
    switch (action.type) {
        case GET_USER_GROUP_REQUEST:
            return setLoadingUserGroup(state, true);
        case GET_USER_GROUP_SUCCESS:
            return updateUserGroup(state, action);
    }
    return state;
}

function updateUserGroup(state: UserGroupState, action: IGetUserGroupSuccessAction) {

    var newState: UserGroupState = update(state, {
        metaData: {
            $set: action.userGroup
        }
    });

    return setLoadingUserGroup(newState, false);
}

function setLoadingUserGroup(state: UserGroupState, loading: boolean) {
    var newState: UserGroupState = update(state, {
        loading: { $set: loading }
    });

    return newState;
}